import { Buffer } from "buffer";

const CHAVE_SESSAO = "vbgSessao";

export interface SessaoPersistida {
  nome: string;
  perfil: string;
  jwt: string;
  empresa: string;
  email: string;
  empresaId: string;
  pesquisaRespondida: boolean;
  popupVbg: any;
}

function tokenExpirado(jwt: string): boolean {
  const partes = jwt.split(".");

  if (partes.length !== 3) return true;

  try {
    const base64 = partes[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(Buffer.from(base64, "base64").toString("utf-8"));

    if (typeof payload.exp !== "number") return false;

    return payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}

export function gravarSessao(sessao: SessaoPersistida): void {
  try {
    sessionStorage.setItem(CHAVE_SESSAO, JSON.stringify(sessao));
  } catch {
    // navegador pode bloquear storage (modo privado/cota); sessao segue apenas em memoria
  }
}

export function limparSessao(): void {
  try {
    sessionStorage.removeItem(CHAVE_SESSAO);
  } catch {
    // navegador pode bloquear storage (modo privado/cota)
  }
}

export function lerSessao(): SessaoPersistida | null {
  let bruto: string | null = null;

  try {
    bruto = sessionStorage.getItem(CHAVE_SESSAO);
  } catch {
    return null;
  }

  if (!bruto) return null;

  let sessao: SessaoPersistida | null = null;

  try {
    sessao = JSON.parse(bruto);
  } catch {
    limparSessao();
    return null;
  }

  // o /login emite token de 4h e nao ha rota de refresh: restaurar token vencido deixaria a UI logada com toda chamada em 401
  if (!sessao || !sessao.jwt || tokenExpirado(sessao.jwt)) {
    limparSessao();
    return null;
  }

  return sessao;
}
